import { ScriptType } from "@/enums/campaigns";
import { GAIL_API } from "./common/constants/routes";

/**
 * v1 type-scoped script URL (`/v1/scripts/{type}[/{id}]`).
 * For versioned scripts prefer `getScriptApiUrl` / `GetScriptV2Url` in
 * `@/utils/scriptVersioning/api` when `organization.features.scriptsApiVersion` is v2.
 */
export const GetScriptUrl = (id: string, scriptType: ScriptType) => {
  let type = "";

  switch (scriptType) {
    case ScriptType.Phone:
      type = "phone";
      break;
    case ScriptType.PhoneBlaster:
      type = "blaster";
      break;
    case ScriptType.Email:
    case ScriptType.EmailBlaster:
      type = "email";
      break;
    case ScriptType.Text:
    case ScriptType.TextBlaster:
      type = "text";
      break;
  }

  if (type === "") {
    return "";
  }

  return `${GAIL_API}/v1/scripts/${type}${id ? `/${id}` : ""}`;
};
